import { BaseModel } from "sjs-base-model";
import ApiTokenModel from "../../models/token/ApiTokenModel";
import configuration from "../../utilities/configuration";
import * as EffectUtility from "../../utilities/EffectUtility";



export async function registerInternalUser(userJson) {
    const endpoint = configuration.apiServer + configuration.apiInternalUsersPath;
    return EffectUtility.postToModel(BaseModel, endpoint, userJson);
}

export async function generateApiTokenForInternalUser() {
    const endpoint = configuration.tokenServiceApiTokenGeneration;
    return EffectUtility.getToModel(ApiTokenModel, endpoint);
}

export async function generateMarketplaceTokenForAdmin(marketplaceToken) {
    const endpoint = configuration.tokenServiceApiTokenGeneration;
    return EffectUtility.getToModel(ApiTokenModel, endpoint, marketplaceToken);
}